import styled from "styled-components"

export const DropdownIconWrapper = styled.div`
  display: flex;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translate(0, -50%);
  padding: 5px;
  border-radius: 3px;

  &:hover {
    background-color: #e9f0f7;
  }
`

export const DropdownOverlayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const DropdownOverlayButton = styled.button`
  background: transparent;
  cursor: pointer;
  border: 0;
  border-radius: 3px;
  padding: 10px 12px;
  font-size: 12px;

  display: flex;
  align-items: center;
  gap: 6px;

  :hover {
    background: ${props => props.removeButton ? '#fae7e4' : '#f1f9ff'};
  }

  span {
    ${props => props.removeButton && 'color: #E83535;'};
  }
`